import type { Routes } from '@angular/router';
import { OnyxFormMode } from '@onyx/angular';
import type { FormResolverData } from '../../common/interfaces/common/form-resolver-data';
import type { DelegationForm } from './common/helpers/delegation-form.helper';
import { addDelegationResolver } from './common/resolvers/add-delegation.resolver';
import { delegationCardResolver } from './common/resolvers/delegation-card.resolver';
import { editDelegationResolver } from './common/resolvers/edit-delegation.resolver';

export type DelegationFormResolverData = FormResolverData<DelegationForm>;

export const DELEGATIONS_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'prefix',
    loadComponent: () =>
      import('./delegations-list/delegations-list.component').then(
        (m) => m.DelegationsListComponent,
      ),
  },
  {
    path: 'add',
    loadComponent: () =>
      import('./delegation-form/delegation-form.component').then(
        (m) => m.DelegationFormComponent,
      ),
    data: { mode: OnyxFormMode.ADD },
    resolve: { data: addDelegationResolver },
  },
  {
    path: ':uuid',
    children: [],
    resolve: { _: delegationCardResolver },
  },
  {
    path: ':uuid/edit',
    loadComponent: () =>
      import('./delegation-form/delegation-form.component').then(
        (m) => m.DelegationFormComponent,
      ),
    data: { mode: OnyxFormMode.EDIT },
    resolve: { data: editDelegationResolver },
  },
] as const;
